module.exports = __webpack_public_path__ + "img/四川天府新区学恩幼儿园.fcb2c65a.jpg";